const NAME = "POLL_COMPARISON";

export default NAME;